import _regenerator from "/Users/ahmerafzal/Documents/Work/Brandripplr/v2/project/brandripplr/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/ahmerafzal/Documents/Work/Brandripplr/v2/project/brandripplr/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import { reactive } from "vue";
import { store } from "@/stores/store";
import { BrandService, CLIENT_PROTOCOL_SECTIONS, CLIENT_PROTOCOL_SCOPE, buildClientProtocols, hasClientProtocolContent } from "@/services/brand.service";
export var clientProtocolsViewDialog = reactive({
  showDialog: false,
  brandId: null
});
export var closeClientProtocolsViewDialog = function closeClientProtocolsViewDialog() {
  clientProtocolsViewDialog.showDialog = false;
};
// brandId: show that brand's protocols (e.g. from a tracker row); without it,
// the brand selected in the header.
export var openClientProtocolsViewDialog = function openClientProtocolsViewDialog() {
  var brandId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  clientProtocolsViewDialog.brandId = brandId || null;
  clientProtocolsViewDialog.showDialog = true;
};
export default {
  name: "ClientProtocolsViewDialog",
  data: function data() {
    return {
      store: store,
      loading: false,
      brand: null,
      protocolSections: CLIENT_PROTOCOL_SECTIONS,
      protocolScope: CLIENT_PROTOCOL_SCOPE,
      activeProtocolKey: CLIENT_PROTOCOL_SECTIONS[0].key,
      activeSource: CLIENT_PROTOCOL_SCOPE.COMPANY,
      clientProtocolsViewDialog: clientProtocolsViewDialog,
      closeClientProtocolsViewDialog: closeClientProtocolsViewDialog
    };
  },
  computed: {
    brandProtocols: function brandProtocols() {
      var _this$brand;
      return buildClientProtocols((_this$brand = this.brand) === null || _this$brand === void 0 ? void 0 : _this$brand.client_protocols);
    },
    companyProtocols: function companyProtocols() {
      var _this$brand2;
      return buildClientProtocols((_this$brand2 = this.brand) === null || _this$brand2 === void 0 || (_this$brand2 = _this$brand2.company) === null || _this$brand2 === void 0 ? void 0 : _this$brand2.client_protocols);
    },
    brandHasContent: function brandHasContent() {
      var _this$brand3;
      return hasClientProtocolContent((_this$brand3 = this.brand) === null || _this$brand3 === void 0 ? void 0 : _this$brand3.client_protocols);
    },
    companyHasContent: function companyHasContent() {
      var _this$brand4;
      return hasClientProtocolContent((_this$brand4 = this.brand) === null || _this$brand4 === void 0 || (_this$brand4 = _this$brand4.company) === null || _this$brand4 === void 0 ? void 0 : _this$brand4.client_protocols);
    },
    // The selectable sources. Both appear (as tabs) only when the brand has its
    // own protocols AND the company has shared ones.
    sources: function sources() {
      var list = [];
      if (this.brandHasContent) {
        list.push({
          key: CLIENT_PROTOCOL_SCOPE.BRAND,
          label: "This brand"
        });
      }
      if (this.companyHasContent) {
        var _this$brand5;
        list.push({
          key: CLIENT_PROTOCOL_SCOPE.COMPANY,
          label: ((_this$brand5 = this.brand) === null || _this$brand5 === void 0 || (_this$brand5 = _this$brand5.company) === null || _this$brand5 === void 0 ? void 0 : _this$brand5.company_name) || "Company"
        });
      }
      if (list.length === 0) {
        var _this$brand6;
        // Nothing defined anywhere — show the company (shared) view, empty.
        list.push({
          key: CLIENT_PROTOCOL_SCOPE.COMPANY,
          label: ((_this$brand6 = this.brand) === null || _this$brand6 === void 0 || (_this$brand6 = _this$brand6.company) === null || _this$brand6 === void 0 ? void 0 : _this$brand6.company_name) || "Company"
        });
      }
      return list;
    },
    currentProtocols: function currentProtocols() {
      return this.activeSource === CLIENT_PROTOCOL_SCOPE.BRAND ? this.brandProtocols : this.companyProtocols;
    },
    activeProtocolLabel: function activeProtocolLabel() {
      var _this = this;
      var section = this.protocolSections.find(function (s) {
        return s.key === _this.activeProtocolKey;
      });
      return section ? section.label : "";
    }
  },
  methods: {
    hasProtocolContent: function hasProtocolContent(key) {
      var _this$currentProtocol;
      var value = ((_this$currentProtocol = this.currentProtocols) === null || _this$currentProtocol === void 0 ? void 0 : _this$currentProtocol[key]) || "";
      return value.replace(/<(.|\n)*?>/g, "").trim().length > 0;
    },
    load: function load() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _store$currentUser, _store$currentBrand, _store$currentBrand2;
        var brandId, _yield$BrandService$g, brand;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this2.activeProtocolKey = _this2.protocolSections[0].key;
              // Client protocols are an internal staff-only reference.
              if (!(((_store$currentUser = store.currentUser) === null || _store$currentUser === void 0 ? void 0 : _store$currentUser.user_type) !== "staff")) {
                _context.n = 1;
                break;
              }
              _this2.brand = null;
              closeClientProtocolsViewDialog();
              return _context.a(2);
            case 1:
              brandId = clientProtocolsViewDialog.brandId || ((_store$currentBrand = store.currentBrand) === null || _store$currentBrand === void 0 ? void 0 : _store$currentBrand.id);
              if (brandId) {
                _context.n = 2;
                break;
              }
              _this2.brand = null;
              return _context.a(2);
            case 2:
              _this2.loading = true;
              _this2.brand = null;
              _context.n = 3;
              return BrandService.getBrand(brandId);
            case 3:
              _yield$BrandService$g = _context.v;
              brand = _yield$BrandService$g.brand;
              _this2.brand = brand || (brandId === ((_store$currentBrand2 = store.currentBrand) === null || _store$currentBrand2 === void 0 ? void 0 : _store$currentBrand2.id) ? store.currentBrand : null);
              // Default to the brand's own protocols when present, otherwise the company's.
              _this2.activeSource = _this2.brandHasContent ? CLIENT_PROTOCOL_SCOPE.BRAND : CLIENT_PROTOCOL_SCOPE.COMPANY;
              _this2.loading = false;
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  },
  watch: {
    "clientProtocolsViewDialog.showDialog": {
      handler: function handler(val) {
        if (val) {
          this.load();
        }
      }
    }
  }
};